"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
const lodash_1 = require("lodash");
const sg = __importStar(require("@integro/slickg"));
const attachments_1 = require("./helpers/attachments");
const helpers_1 = require("./helpers");
function initialize(app) {
    const attachmentsHelper = new attachments_1.AttachmentsHelper(app);
    (0, lodash_1.set)(app, 'attachments', attachmentsHelper);
    (0, lodash_1.set)(app, 'helpers', helpers_1.appHelpers);
    sg.registerFormatter('statusDot', statusDot);
    sg.registerFormatter('attachment', attachmentsHelper.slickColumnFormatter());
    sg.VueSlickgrid.setDefaults(grid => {
        return {
            rowClass(data) {
                if ((0, lodash_1.get)(data, 'inactive')) {
                    return app.config.bgClass.inactive;
                }
            }
        };
    });
}
exports.initialize = initialize;
function statusDot() {
    const colors = (0, lodash_1.get)(window, '$app.config.statuses.colors');
    const statusDotFormatter = (row, cell, value, columnDef, dataContext, grid) => {
        const field = (0, lodash_1.get)(columnDef, 'field') || '';
        const fieldValue = field && (0, lodash_1.get)(dataContext, field);
        if (!fieldValue) {
            return value;
        }
        let color = (0, lodash_1.get)(colors, fieldValue);
        if (!color) {
            return value;
        }
        return `<span class="mr-2 ml-1 text-${color}">⬤</span>${value}`;
    };
    (0, lodash_1.set)(statusDotFormatter, 'exportRawData', true);
    return statusDotFormatter;
}
